<template>
	<img :class="['img-comp', isInViewport ? 'img-comp--appear' : '']" :src="heritedData.url" :alt="heritedData.title">
</template>

<script>
	import scrollMonitor from 'scrollmonitor'

	export default {
		name: 'img-comp',
		props: ['heritedData'],
		data () {
			return {
				isInViewport: false
			}
		},
		mounted () {
			const self = this

			setTimeout(() => {
				const elementWatcher = scrollMonitor.create(self.$el)

				elementWatcher.enterViewport(() => {
					self.isInViewport = true
				})
			}, 0)
		}
	}
</script>

<style lang="scss">
	.img-comp {
		opacity: 0;
		transform: translateY(150px);
		transition: all 1s .4s cubic-bezier(0.215, 0.61, 0.355, 1);

		&.img-comp--appear {
			opacity: 1;
			transform: translateY(0);
		}
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/ui/ImageComp.vue?16ac89b8